var classes = {"sharePopoverRoot":"u1dWK","sharePopoverWrapper":"eWwEb","sharePopoverContent":"oF2MJ","sharePopoverLinksContainer":"CrhCY","sharePopoverDivider":"PNUty","sharePopoverActionsContainer":"PcfBm","sharePopoverLink":"rGYj3"};

export { classes as default };
